import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany } from '@apexdesigner/schema-tools';

export const serviceTask = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    referenceNumber: z
      .number()
      .nullable()
      .optional()
      .describe('Human-readable reference number'),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Optional name for this task'),

    queue: z
      .string()
      .nullable()
      .optional()
      .describe('Queue where this task is processed'),

    status: z
      .enum(['Active', 'Paused', 'Complete', 'Canceled', 'Error'])
      .nullable()
      .optional()
      .describe('Current state of this task'),

    attempts: z
      .number()
      .nullable()
      .optional()
      .describe('Number of times execution was attempted'),

    claimedBy: z
      .string()
      .nullable()
      .optional()
      .hidden()
      .describe('Service processing this task'),

    claimedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When processing started on this task'),

    errorMessage: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Error details if the task failed'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Input and working data for this task'),

    completedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this task was finished'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    tokenId: z.uuid().hidden().describe('Foreign key to Token'),

    token: belongsTo('Token'),

    tokens: hasMany('Token', 'currentServiceTaskId'),

    serviceTaskHistories: hasMany('ServiceTaskHistory', 'serviceTaskId'),
  })
  .describe('A task that is processed by an automated service')
  .as('ServiceTask');

export { serviceTask as serviceTaskSchema };
